//Used to convert seconds to milliseconds. Open ID token expiration uses seconds since epoch time.
const MILLISECONDS_IN_SECOND = 1000;
export class AuthorizeController {
    static $inject = ['$state', 'AuthenticationService', 'OidcService', 'LoadingService', 'AuthorizeServiceFactory'];
    constructor($state, AuthenticationService, OidcService, LoadingService, AuthorizeServiceFactory) {
        'ngInject';
        this.$state = $state;
        this.AuthenticationService = AuthenticationService;
        this.OidcService = OidcService;
        this.LoadingService = LoadingService;
        this.AuthorizeServiceFactory = AuthorizeServiceFactory;
        this.LoadingService.startLoading(false);
    }
    async $onInit() {
        try {
            const user = await this.AuthorizeServiceFactory.signInRedirect();
            await this.AuthorizeServiceFactory.authenticate(user);
        }
        catch (e) {
            console.error(e);
            this.$state.go('applicationError', { error: e });
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
AuthorizeController.$inject = ['$state', 'AuthenticationService', 'OidcService', 'LoadingService', 'AuthorizeServiceFactory'];
